// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__zJbFg","imageUploader":"EGiftCard_imageUploader__2biLi"};